import { el } from "../lib/dom.js";

/**
 * A rule id as it is printed (DCTA-120, review P3-2): micro type for the eye, "Reference FW-OVERRIDE" for a
 * screen reader. DCTA-124 (Umakhan's ruling, 5 Oct): rule ids are judge mode's and the audit view's only —
 * every caller puts this under a `.judge` root, never on a customer screen.
 */
export function ruleId(id: string, tag: "span" | "small" = "span"): HTMLElement {
  return el(tag, { class: "rule" }, [el("span", { class: "vis-hidden" }, ["Reference "]), id]);
}
